import {HttpExclude, Request, RequestExpose} from '@simpli/serialized-request'
import {ExpansibleCollection} from '@simpli/resource-collection'
import {OrbitRoundReward} from '../resource/OrbitRoundReward'

@HttpExclude()
export class OrbitRoundRewardCollection extends ExpansibleCollection<
  OrbitRoundReward
> {
  resource?: IOrbitRoundRewardCollectionResourcesHolder

  @RequestExpose() limit: number | null = null
  @RequestExpose() idOrbitRoundRewardPk: number[] | null = null
  @RequestExpose() address: string | null = null
  @RequestExpose() round: number | null = null
  /** pending | approved | rejected | claimed | expired | distributed_to_others (group) | e.g. rejected_distributed_to_others */
  @RequestExpose() statusFilter: string | null = null
  /** blockchain_version.networkIdentifier: 'neo3/mainnet' | 'neo3/testnet' */
  @RequestExpose() networkIdentifier: string | null = null

  constructor() {
    super(OrbitRoundReward)
  }

  queryAsPage() {
    return this.listOrbitRoundReward()
  }

  async listOrbitRoundReward() {
    return await Request.get(`/client/orbit-round-reward`, {
      params: this.params,
    })
      .name('listOrbitRoundReward')
      .as(this)
      .getResponse()
  }

  async claimOrbitRoundReward(payload: {
    address: string
    transactionHash: string
    idOrbitRoundRewardPks: number[]
  }): Promise<number> {
    return await Request.post(`/client/orbit-round-reward/claim`, payload)
      .name('claimOrbitRoundReward')
      .asNumber()
      .getData()
  }

  async countUserPoolClaims(address: string): Promise<number> {
    const params: Record<string, string> = {address}
    return await Request.get(`/client/orbit-round-reward/count-pool-claims`, {
      params,
    })
      .name('countUserPoolClaims')
      .asNumber()
      .getData()
  }

  async sumUserRewards(
    address: string
  ): Promise<Array<{amount: number; symbol: string; decimals: number}>> {
    const params: Record<string, string> = {address}
    return await Request.get(`/client/orbit-round-reward/sum-rewards`, {
      params,
    })
      .name('sumUserRewards')
      .asAny()
      .getData()
  }
}

export interface IOrbitRoundRewardCollectionResourcesHolder {}
